"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = exports.getIsLoggedIn = void 0;
const ajax_1 = require("./ajax");
const getIsLoggedIn = (sitePath) => {
    return new Promise((resolve, reject) => {
        (0, ajax_1.ajax)(`${sitePath}/ajax-verify-authorization`).then(data => {
            if (data && data.isLoggedIn) {
                resolve(true);
            }
            else {
                resolve(false);
            }
        }, err => {
            reject(err);
        });
    });
};
exports.getIsLoggedIn = getIsLoggedIn;
const getDisplayName = (sitePath) => {
    return new Promise((resolve, reject) => {
        (0, ajax_1.ajax)(`${sitePath}/getDisplayName`).then(data => {
            if (data && data.displayName) {
                resolve(data.displayName);
            }
            else {
                resolve('');
            }
        }, err => {
            reject(err);
        });
    });
};
exports.getDisplayName = getDisplayName;
//# sourceMappingURL=sso.js.map